let Portfolio = [
  {
    id: 1,
    image: "images/ecommerce.png",
    cat: "e-com",
  },
  {
    id: 2,
    image: "images/japanese.png",
    cat: "practice",
  },
  {
    id: 3,
    image: "images/japanese.png",
    cat: "practice",
  },

  {
    id: 4,
    image: "images/proshop.png",
    cat: "e-com",
  },
  {
    id: 5,
    image: "images/practice.png",
    cat: "practice",
  },
  {
    id: 6,
    image: "images/rexlist.png",
    cat: "practice",
  },

  { id: 9, image: "images/admin.png", cat: "react" },

  { id: 10, image: "images/admin1.png", cat: "react" },

  { id: 11, image: "images/portfolio.png", cat: "portfolio" },

  { id: 12, image: "images/practice3.png", cat: "practice" },
];

export default Portfolio;
